var React = require('react');

function BallPile (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M176 168a80 80 0 1 0 80 80 80 80 0 0 0-80-80zm224 0a80 80 0 1 0 80 80 80 80 0 0 0-80-80z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M80 352a80 80 0 1 0 80 80 80 80 0 0 0-80-80zM288 0a80 80 0 1 0 80 80 80 80 0 0 0-80-80zm0 352a80 80 0 1 0 80 80 80 80 0 0 0-80-80zm208 0a80 80 0 1 0 80 80 80 80 0 0 0-80-80z","className":"fa-primary","key":2})]);
}

BallPile.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = BallPile;

BallPile.default = BallPile;
